// extracted by mini-css-extract-plugin
export default {"dropCandidate":"PatientInsurancesTable_dropCandidate__ZxFeQ"};